// extracted by mini-css-extract-plugin
module.exports = {"root":"Forms_root__3RuP6","halfWidth":"Forms_halfWidth__2asdZ","marginBottom":"Forms_marginBottom__1X-2k","buttons":"Forms_buttons__3KTrk"};